<template>
  <div>
    <span
      class="display-value-label font-weight-medium text--primary"
      v-text="label"
    />
    <br class="d-flex d-sm-none">
    <span
      v-if="!isUrl"
      class="font-weight-light"
      v-text="transformedValue"
    />
    <a
      v-if="isUrl"
      :href="transformedValue"
      class="no-reformat"
      target="_blank"
    >
      {{ transformedValue }}
    </a>
  </div>
</template>

<script>
  import Themeable from 'vuetify/lib/mixins/themeable'

  export default {
    name: 'DisplayValue',

    mixins: [Themeable],

    props: {
      value: {
        type: [String, Number, Boolean],
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      dataType: {
        type: String,
        default: 'string',
      },
    },

    computed: {
      isUrl () {
        return this.dataType === 'url'
      },

      transformedValue () {
        let result = this.value

        if (this.dataType !== 'string') {
          switch (this.dataType) {
            case 'boolean':
              result = this.asBoolean(this.value)
              break
            default:
              break
          }
        }

        return result
      },
    },

    methods: {
      asBoolean (value) {
        return value ? 'Yes' : 'No'
      },
    },
  }
</script>

<style lang="sass">
.display-value-label
  &:after
    content: ": "
</style>
